import { render, staticRenderFns } from "./PreviousButton.vue?vue&type=template&id=a3feb118&scoped=true&"
import script from "./PreviousButton.vue?vue&type=script&lang=ts&"
export * from "./PreviousButton.vue?vue&type=script&lang=ts&"
import style0 from "./PreviousButton.vue?vue&type=style&index=0&id=a3feb118&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3feb118",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/1/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
